import React from "react";
import { Card, Row, Col, Typography } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";

const { Title, Text } = Typography;

const SalesReport = ({ salesData, trendData }) => {
  // Transform data for Recharts
  const chartData =
    trendData?.map((item) => ({
      date: moment(item._id).format("MMM DD"),
      Sales: item.totalSales,
      Orders: item.orderCount,
    })) || [];

  return (
    <Row gutter={16}>
      <Col span={16}>
        <Card title="Sales Trend" className="mb-4">
          <ResponsiveContainer width="100%" height={350}>
            <LineChart
              data={chartData}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis yAxisId="left" />
              <YAxis yAxisId="right" orientation="right" />
              <Tooltip
                formatter={(value, name) => {
                  return name === "Sales" ? `$${value.toFixed(2)}` : value;
                }}
              />
              <Legend />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="Sales"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="Orders"
                stroke="#82ca9d"
              />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </Col>
      <Col span={8}>
        <Card title="Sales Summary" className="mb-4">
          <div className="mb-4">
            <Text strong>Total Sales:</Text>
            <Title level={4}>
              ${salesData?.totalSales?.toFixed(2) || "0.00"}
            </Title>
          </div>
          <div className="mb-4">
            <Text strong>Total Orders:</Text>
            <Title level={4}>{salesData?.totalOrders || 0}</Title>
          </div>
          <div>
            <Text strong>Average Order Value:</Text>
            <Title level={4}>
              ${salesData?.averageOrderValue?.toFixed(2) || "0.00"}
            </Title>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default SalesReport;
